import { Component, Input } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { AbstractInputComponent } from '../abstract-input.component';
import {
  DateFilterFn,
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerInputEvent,
  MatDatepickerToggle,
} from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { MatError, MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'logpn-input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.scss'],
  providers: [provideNativeDateAdapter(), DatePipe],
  imports: [
    MatFormField,
    MatInput,
    FormsModule,
    MatDatepickerInput,
    ReactiveFormsModule,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatError,
    TranslocoPipe,
    MatError,
    TranslocoPipe
],
})
export class InputDateComponent extends AbstractInputComponent {
  INPUT_FORMAT: string = 'yyyy-MM-dd';

  @Input() startAt: Date | null = null;
  @Input() dateFilter!: DateFilterFn<Date | null>;
  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;

  constructor(private readonly datePipe: DatePipe) {
    super();
  }

  override defaultErrorMessages() {
    return {
      matDatepickerParse: 'forms.errors.format-date',
      ...this.defaultRequiredErrorMessage(),
    };
  }

  setFormValue($event: MatDatepickerInputEvent<any, any>): void {
    if ($event.value && this._control) {
      this._control.setValue(this.datePipe.transform($event.value, this.INPUT_FORMAT));
    }
  }
}
